import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  ScenarioSelectionModelDetailsStepContent,
} from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionRedefined/ScenarioSelectionModelDetailsStepTemplate/Content';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['title', 'performanceSectionTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('investmentMixSectionTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('investmentMixSectionDescription', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('expenseRatio', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly);

export const ScenarioSelectionModelDetailsStepTemplate = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ScenarioSelectionModelDetailsStepContent}
    />
  );
};

ScenarioSelectionModelDetailsStepTemplate.propTypes = {};
